<template>
    <div>
        <div class="text-center">
            <h3 class="mt-0">Terms Of Use</h3>
            <p class="m-0">Activix Inc. ▪ Version 01.12</p>
            <p class="m-0">Effective date : December 1st 2017</p>
        </div>
        <div class="text-justify">
            <h4>1. General Terms</h4>
            <p>
                These Terms of Use (hereinafter the "<strong>Terms</strong>") detail your rights and
                obligations in connection with the access and use of the products and services
                provided by Activix (hereinafter the "<strong>Products</strong>") and well as the
                transactions and purchases that Activix provides you. These Products include,
                amongst others, NioText.
            </p>
            <p>YOU MUST READ THESE TERMS CAREFULLY AND CONSULT THEM BEFORE USING THE PRODUCTS.</p>
            <p>
                By accessing or using the Products or their features, as well as by expressing your
                consent in another form, you agree to be bound by the provisions of the Terms and
                the documents to which the Products refer. These Terms bind you as much during, as
                after your use of the Products.
            </p>
            <p>
                IF YOU DO NOT AGREE TO ALL OF THE TERMS OR ANY CHANGES TO THE TERMS, YOU MUST
                DISCONTINUE USING THE PRODUCTS IMMEDIATELY.
            </p>
            <p>
                We also invite you to contact us for any questions or comments regarding the Terms
                at info@activix.ca
            </p>

            <p><strong>1.2.</strong> Definitions</p>
            <p>
                « <strong><em>Activix</em></strong> », « <strong><em>ours</em></strong> », «
                <strong><em>us</em></strong> » ou « <strong><em>notre</em></strong> »
                <strong>→</strong> refers to the company Activix Inc. ;
            </p>
            <p>
                « <strong><em>Products</em></strong> » <strong>→</strong> refers to the web, mobile,
                or other products developed by Activix available to Activix Customer on multiple
                platforms;
            </p>
            <p>
                « <strong><em>Clients Activix</em></strong> » <strong>→</strong> means paying
                customers who have subscribed to a commercial service offered by Activix Inc. in
                addition to the Products ;
            </p>
            <p>
                « <strong><em>Unsolicited Communications</em></strong> » <strong>→</strong> refers
                to the meaning given at paragraph 4.1
            </p>
            <p>
                « <strong><em>Terms</em></strong> » <strong>→</strong> means the present Terms of
                Use set forth in this document ;
            </p>
            <p>
                « <strong><em>Additional Terms</em></strong> » <strong>→</strong> refers to the
                meaning given at paragraph 1.4
            </p>
            <p>
                « <strong><em>Content</em></strong> » <strong>→</strong> means any text, image,
                audio file, video, miscellaneous multimedia element, software, code, or any other
                information or material published, existing, being accessible or being sent from the
                Products ;
            </p>
            <p>
                « <strong><em>Services</em></strong> » <strong>→</strong> refers to all the services
                offered by the Products, accessible via the Products on multiple platforms ;
            </p>
            <p>
                « <strong><em>User</em></strong> », « <strong><em>you</em></strong> », «
                <strong><em>yours</em></strong> » ou « <strong><em>votre</em></strong> »
                <strong>→</strong> refers to the person, physical or moral, accessing or using the
                Products, their Services or their Content;
            </p>
            <p>
                <strong>1.3.</strong> Privacy Policy: These Terms include your acceptance of the
                terms and conditions set out in our Privacy Policy. This Policy is also governed by
                these Terms in the event of a dispute or inconsistency relating to it.
            </p>
            <p>
                <strong>1.4.</strong> Additional Terms: These Terms may be modified or superseded by
                Additional Terms relating to the Content and the Services offered by the Products
                (hereinafter the "<strong>Additional Terms</strong>"). These Additional Terms will
                replace any previous terms with which they would be in conflict or inconsistent.
            </p>
            <p>
                <strong>1.5.</strong> The Products are intended Canadian residents 18 years of age
                and over.
            </p>

            <h4>2. Restrictions of Use</h4>
            <p>
                <strong>2.1.</strong> The Products are intended for your commercial use as part of
                your client account with Activix. When you access or use the Products, you agree:
            </p>
            <p>
                <strong>2.1.1.</strong> not to use the Products for any unlawful purpose under
                applicable law or under these Terms ;
            </p>
            <p>
                <strong>2.1.2.</strong> not to defame, disparage or make any comment of an obscene,
                derogatory, or offensive nature or to use these Products or their Content to
                generate a dispute with us or any third party, including a dispute that would engage
                our responsibility or that of a third party ;
            </p>
            <p>
                <strong>2.1.3.</strong> not to remove or revise the Content of the Products when
                such content does not emanate from you ;
            </p>
            <p>
                <strong>2.1.4.</strong> not to decompile, disassemble, adapt, translate, transmit,
                arrange, modify, copy, consolidate, sublicense, export, merge, transfer, adapt,
                loan, lease, assign, share, outsource, host, publish, make the Products available on
                a third party platform (such as by means of hyperlinking “linking”), “framing” or
                “spidering”, refer to deep links, create derivative content or use the Products or
                its Content contrary to these Terms or the laws in force, as well as any other
                Additional Terms, in any form or by any means, physical, electronic or otherwise ;
            </p>
            <p>
                <strong>2.1.5.</strong> not to send any form of unsolicited e-mail or message
                (“spam”), commercial or otherwise ;
            </p>
            <p>
                <strong>2.1.6.</strong> not to use the Products or their Content to distribute
                computer viruses, malicious program or any other program or malicious code ;
            </p>
            <p>
                <strong>2.1.7.</strong> not to attempt to probe, analyze or test the vulnerabilities
                of the Products or its network and not to attempt to violate the security or
                authentication network or any other network or security measure of the Products ;
            </p>
            <p>
                <strong>2.1.8.</strong> not to present and not to suggest or make believe that we
                recommend, a person, physical or moral, unless we obtain a separate written
                authorization from us for that purpose ;
            </p>
            <p>
                <strong>2.1.9.</strong> not to access data not intended for you or to connect to a
                server or account that you are not authorized to access ;
            </p>
            <p>
                <strong>2.1.10.</strong> to be held responsible for all costs, fees and expenses
                that may be incurred by your use of the Products.
            </p>
            <p>
                <strong>2.2.</strong> Notwithstanding section 2.1, only Activix Customers are
                authorized to use the Products for commercial purposes, solely through the Services
                or by referring to the Products by means of hyperlinks. At no time will an Activix
                Customer be permitted to use the Content outside of the Products or a related
                service provided by Activix Inc., unless explicitly stated otherwise.
            </p>
            <p>
                <strong>2.3.</strong> We reserve the right to prevent or suspend partial or complete
                access to the Products if a User does not comply with these Terms, as well as any
                applicable law or regulation.
            </p>

            <h4>3. Ownership, Use and Intellectual Property Rights</h4>
            <p>
                <strong>3.1.</strong> The Content of Activix Inc. is protected by Canadian and
                foreign copyrights, trademarks and other laws. Unless otherwise stated, the Content
                of the Products is the property of Activix Inc., its customers and / or its
                suppliers. Unauthorized use of the Content of Activix Inc. may violate copyright,
                trademark and other laws. Activix Inc. may modify or delete all or part of the
                Content of the Products in its sole discretion, at any time and without notice.
            </p>
            <p>
                <strong>3.2.</strong> The Products and all related intellectual property rights
                (including their Content) are and remain our exclusive property or that of our
                licensors. We and our licensors reserve all our intellectual property rights
                (including, but not limited to, copyrights, trademarks, domain names, design rights,
                database rights, patents, and other intellectual property rights) without regard to
                the registration of these rights in any country.
            </p>
            <p>
                <strong>3.3.</strong> Nothing in the Terms grants you any right in the Products
                other than what is necessary to access it. You agree not to attempt to circumvent or
                remove any intellectual property notices on the Products, including any digital
                rights or other technological security rights posted on the Products.
            </p>

            <h4>4. Communications via the Products</h4>
            <p>
                <strong>4.1.</strong> The Products and their Services do not provide a secure means
                of communication and any information you provide will not be considered as
                confidential. For this reason, you should not send us or communicate between users,
                patentable ideas or patent applications, advertising or marketing suggestions,
                prototypes or any other written or verbal information that you consider confidential
                or commercially sensitive or of value (hereinafter collectively referred to as
                "<strong>Unsolicited Communications</strong>"). While we appreciate your comments,
                you agree not to send us such Unsolicited Communications. Any communication,
                including any Unsolicited Communication, sent to us, communicated through our
                Services or published on the Products are deemed to be our property. By transmitting
                or posting to us on the Products a communication and / or information or message, as
                well as any other element, you agree, subject to our Privacy Policy, that we use
                this information in any way (including reproduction, transmission, publication,
                broadcast and display on any medium and anywhere in the world), free of charge. You
                also agree that we are not under any obligation of confidentiality, nor can we be
                held responsible for any use and / or disclosure of the content of these
                communications.
            </p>
            <p>
                <strong>4.2.</strong> When the Products allow you to communicate with us and / or
                other Users of the Products or third parties, you may not use the Products to
                communicate offensive or illegal content or material (eg, violent, obscene,
                discriminatory content, defamatory or otherwise contrary to good faith). While we
                reserve the right to moderate, monitor, modify, revise or delete notices, comments,
                discussions, chats, publications, transmissions, forums and similar communications
                on the Products from time to time, we are not required to and we assume no liability
                for any content displayed on or transmitted through the Products, or for any error,
                omission, offense, defamatory, obscene or inaccurate statement contained in such
                communications.
            </p>
            <p>
                <strong>4.3.</strong> By using and accessing the Products, you represent and warrant
                that any Content that you provide to us is and remains your own original work, that
                such Content has been lawfully provided to us, that you hold all necessary
                authorizations to provide us with such Content and that you authorize us to disclose
                your name in connection with such Content. By providing us with this Content, you
                waive all moral rights you may have and agree that any personal information you
                provide in your Content may be reused by us, subject to our Privacy Policy.
            </p>

            <h4>5. Provisions Applicable to the Creation and Use of Services with an Account</h4>
            <p>
                <strong>5.1.</strong> When an account is created for you to use our Products, you
                understand and agree that you are solely responsible for maintaining the
                confidentiality of your account, including your password, and are fully responsible
                for all activities that occur under this account, whether intended or not by you.
            </p>
            <p><strong>5.2.</strong> You agree to :</p>
            <p>
                <strong>5.2.1.</strong> notify us of any unauthorized use of your account or any
                other breach of security without delay ; and,
            </p>
            <p><strong>5.2.2.</strong> log out of your account after each use of the Products.</p>
            <p>
                <strong>5.3.</strong> After your account has been created on the Products, you are
                ready to use the Products and their functionalities, in connection with other
                products or services of Activix Inc.
            </p>
            <p>
                <strong>5.4.</strong> You represent and warrant that the owners of the telephone
                numbers to which you send messages or files through our Services and the Products
                have consented or have chosen to accept the receipt of such messages in accordance
                with any applicable law or provision.
            </p>
            <p>
                <strong>5.5.</strong> You represent and warrant that you notify any legal or natural
                person of the registration of their calls made through our Products and for any
                retention of such records. You also agree to comply with any law relating to the
                recording of telephone calls.
            </p>
            <p>
                <strong>5.6.</strong> You agree to comply with any law relating to the sending of
                SMS and MMS messages and to the best commercial practices when using our Services
                and the Products.
            </p>
            <p>
                <strong>5.7.</strong> You understand that any Content, whether publicly displayed on
                the Products or privately transmitted with our Services, is the sole responsibility
                of the person from whom it originates. This means that the User, the Activix
                Customer, and not Activix Inc. or any other subsidiary and partner, are fully
                liable:
            </p>
            <p>
                <strong>5.7.1.</strong> of the Content they transmit or otherwise make available
                through our Services and Products; and,
            </p>
            <p>
                <strong>5.7.2.</strong> to ensure that their Content is accurate, without misleading
                information, and that they do not infringe any intellectual property rights
                belonging to anyone.
            </p>
            <p>
                <strong>5.8.</strong> We have no control over the Content transmitted through our
                Services and Products and we cannot guarantee the accuracy, integrity or quality of
                the Content that is transmitted or communicated. Accordingly, you agree not to hold
                us liable for any inaccuracy, error or omission in the Content or for any loss or
                damage of any nature whatsoever resulting from the use or reliance upon the Content,
                published, transmitted or otherwise made available to Users or third parties via our
                Services and Products.
            </p>
            <p>
                <strong>5.9.</strong> You acknowledge that we make no prior verification of the
                Content posted, published or transmitted by a User or Activix Customer, but that we
                reserve the right (but not the obligation) to refuse or delete any Content made
                available through our Services and Products, which violates these Conditions, or
                which we consider objectionable, in our sole discretion.
            </p>
            <p>
                <strong>5.10.</strong> You expressly acknowledge and agree that we authorize access,
                preserve and disclose information and the Content relating to your account where
                required by law, court order, and even in good faith, if we believe that the access,
                preservation or disclosure is reasonably necessary for:
            </p>
            <p><strong>5.10.1.</strong> complying with a court order ;</p>
            <p><strong>5.10.2.</strong> enforcing these Terms ;</p>
            <p>
                <strong>5.10.3.</strong> responding to allegations of violations of the rights of
                third parties ;
            </p>
            <p><strong>5.10.4.</strong> responding to your customer service requests ; or,</p>
            <p>
                <strong>5.10.5.</strong> protect our rights, our property, the personal safety of
                our employees, the safety of our organization and its affiliates, Users, Activix
                Customers and the public.
            </p>
            <p>
                <strong>5.11.</strong> When you create an account or contact a third party through
                the Products, you agree not to:
            </p>
            <p>
                <strong>5.11.1.</strong> upload, post, communicate, transmit by e-mail, SMS or
                otherwise any Content :
            </p>
            <p>
                <strong>(i)</strong> that is false, inaccurate, misleading, defamatory, harmful,
                threatening, abusive, harassing, discriminatory, vulgar, obscene, hateful, racist,
                or otherwise objectionable or unlawful ;
            </p>
            <p>
                <strong>(ii)</strong> for which you do not have rights to make such Content
                available under any law or any contractual or fiduciary relationship ;
            </p>
            <p>
                <strong>(iii)</strong> that infringes a patent, trademark, trade-secret, copyright
                or other proprietary right belonging to a third party ;
            </p>
            <p>
                <strong>(iv)</strong> which constitutes unsolicited or unauthorized advertising,
                promotional materials (“junk mail”, “spam”, “chain letters”, “pyramid schemes”) or
                any other form of illegal solicitation contrary to these Terms.
            </p>
            <p>
                <strong>5.11.2.</strong> impersonate any person, physical or moral, including but
                not limited to, a member of our personnel or falsely claim to have an affiliation
                with such person ;
            </p>
            <p>
                <strong>5.11.3.</strong> transfer your account to another person without our prior
                authorization ;
            </p>
            <p>
                <strong>5.11.4.</strong> collect, use, or disclose personal information about users,
                including e-mail addresses, without their prior consent or by derogating from
                applicable law in such matters ;
            </p>
            <p>
                <strong>5.11.5.</strong> to take any action that would impose an unreasonable or
                disproportionate burden on our digital infrastructure or those of our subsidiaries ;
            </p>
            <p>
                <strong>5.11.6.</strong> interfere or attempt to interfere with the proper
                functioning of our Services or our Products.
            </p>
            <p>
                <strong>5.12.</strong> You acknowledge that we may establish general practices and
                limitations regarding the use of the Services, including, but not limited to, the
                maximum number of days that your Content will be retained on our Products, the
                Content limit per account, the maximum size of the message or Content that can be
                issued by an account, the maximum number of times, and the maximum time for which
                you can access or use the Services in a given period of time. You further
                acknowledge that we reserve the right to change these general practices and limits
                at any time, at our sole discretion, with or without notice.
            </p>
            <p>
                <strong>5.13.</strong> Without limiting our right to any other remedy, we may, in
                our sole discretion, limit, suspend or terminate the Services and User accounts
                (including Activix Customer accounts), prohibit access to the Products and take
                technical and legal measures to prevent certain Users from accessing the Products as
                well as removing and removing any Content and Services, for any reason, including,
                but not limited to, :
            </p>
            <p>
                <strong>5.13.1.</strong> accounts that have not been confirmed by the Users or
                Activix Customers or have been inactive for a period of more than six (6) months ;
            </p>
            <p>
                <strong>5.13.2.</strong> when we believe that you have violated or acted
                inconsistently with the Terms of the spirit of the Terms ;
            </p>
            <p>
                <strong>5.13.3.</strong> when we are compelled by a law, a competent court or any
                other governmental body having such a binding power ;
            </p>
            <p>
                <strong>5.13.4.</strong> when you provide false, inaccurate, outdated or incomplete
                information or where we have reasonable grounds to suspect that you have committed
                such acts;
            </p>
            <p><strong>5.13.5.</strong> when you make us the request ;</p>
            <p>
                <strong>5.13.6.</strong> when we must interrupt or make material changes to our
                Services or the Products ;
            </p>
            <p><strong>5.13.7.</strong> when unexpected technical or security problems occur ;</p>
            <p>
                <strong>5.13.8.</strong> when you have or believe that you have engaged in unlawful
                activities, including, without limitation, fraud ; and, or,
            </p>
            <p>
                <strong>5.13.9.</strong> when you violate our Privacy Policy or applicable privacy
                laws.
            </p>
            <p>
                <strong>5.14.</strong> You acknowledge and agree that any termination of your access
                to the Services under any provision of these Terms may be made without notice and
                that we may immediately disable or delete your account and all related Content.
                Consequently, you agree not to be held responsible to you or a third party for the
                termination of your account, or the termination of your access to the Services and
                Products.
            </p>

            <h4>6. Account Creation</h4>
            <p>
                <strong>6.1.</strong> If you are not an Activix Customer, you may not use the
                Products.
            </p>
            <p>
                <strong>6.2.</strong> While we strive to keep the Products available at all times,
                the Products may be temporarily unavailable for 12 hours a week, continuously or
                discontinuously, for technical reasons.
            </p>
            <p>
                <strong>6.3.</strong> In the event that a paid feature of the Products is defective
                for an extended period, we may need to replace this feature with an alternative
                service of equal or greater value. In this case, we will contact you to inform you
                of our intentions.
            </p>
            <p>
                <strong>6.4.</strong> We will do everything reasonably possible to ensure that all
                the information you provide during payment is protected by an encrypted secure
                payment mechanism, but in the absence of negligence on our part we cannot be held
                responsible for any loss you may suffer if a third party accesses the information
                you provide us.
            </p>
            <p>
                <strong>6.5.</strong> The termination of a service contract with Activix Customers
                may not affect any claim due to us under the Terms.
            </p>

            <h4>7. Accuracy of the Content and Availability of the Products</h4>
            <p>
                <strong>7.1.</strong> While we strive to maintain accurate and up-to-date
                information about the Products, we cannot offer any guarantee that the Content is or
                remains available, accurate, complete, reliable, current, and up to date, as well as
                that our Services are free from bugs, errors and omissions.
            </p>
            <p>
                <strong>7.2.</strong> The trust and trustworthiness you place in the Content of the
                Products is at your own risk. We may suspend or terminate the operation of the
                Products at any time and in our sole discretion.
            </p>
            <p>
                <strong>7.3.</strong> Nothing in these Terms shall prejudice our statutory rights
                and obligations.
            </p>

            <h4>8. Notification Policy and Withdrawal for Illegal Content</h4>
            <p>
                <strong>8.1.</strong> In the event of any claim or objection by you regarding
                Content posted on the Products, or if you believe that any Content or sent messages
                violate your copyright, you agree to notify us immediately and not to hold us
                responsible for any damages and claims that may arise when your request is processed
                within ten (10) business days.
            </p>

            <h4>9. Hyperlinks and Third Parties</h4>
            <p>
                <strong>9.1.</strong> The Products may contain hyperlinks or references to
                third-party applications. All these hyperlinks or references are provided for your
                convenience only. We have no control over the content of third party applications
                and we cannot assume any responsibility for any content, material or information
                contained therein. The publication of hyperlinks or references, to an application of
                a third party, does not constitute an approval of the content of this application,
                the products or services of these third parties.
            </p>
            <p>
                <strong>9.2.</strong> Your use of an application from a third party may be governed
                by conditions specific to that application.
            </p>

            <h4>10. Limitation of Liability</h4>
            <p>
                <strong>10.1.</strong> The Products can transmit messages and files that have been
                initiated by you or sent by you to third parties of your choice and also record
                conversations you have with third parties. Thus, you agree not to hold us
                responsible for the Content, messages, actions or inactions that are made by you
                using our Products or Services. We have no control over Activix Users or Clients
                using the Products and we cannot guarantee the truthfulness, quality, safety or
                legality of the Content. We cannot guarantee continuous or secure access to our
                services, and the operation of our Products may be affected by many factors beyond
                our control.
            </p>
            <p>
                <strong>10.2.</strong> You are responsible for obtaining and maintaining all
                computer hardware, software and mobile devices necessary to access the Products and
                Services and any telecommunications charges billed by your wireless carrier for
                using our Services and Products.
            </p>
            <p>
                <strong>10.3.</strong> You understand and agree that we are not responsible for any
                loss incurred by the failure of a message and damages for financial or other loss
                resulting from a delivery failure cannot be claimed. You also understand and agree
                that we are not responsible for all loss, legal claim, and legal procedure intended
                against you or incurred following your illegal recording of conversations with third
                parties.
            </p>
            <p>
                <strong>10.4.</strong> You understand and agree that we are solely responsible for
                ensuring that your messages and files are properly processed and forwarded to the
                applicable network. We cannot be responsible for the final delivery of any
                communication or message initiated through the Products and our Services, as this is
                beyond our control. In addition, we cannot be held responsible for the delay in
                transmitting any communication or message initiated through the Products and our
                Services. These delays depend on several factors related to the wireless networks,
                telephone lines and Internet connection of Users.
            </p>
            <p>
                <strong>10.5.</strong> To the extent permitted by law, you understand and agree that
                we and our licensors cannot be liable for any direct, indirect, incidental, special,
                consequential or exemplary damages that you may incur under the principles of the
                public liability. This includes, but is not limited to, loss of profits, damage to
                reputation, loss of data, the cost of acquiring alternative goods or services, or
                any other intangible loss (although we have been advised of the possibility of such
                damages), resulting from your use or your inability to use our Services or any
                matter relating to our Services and our Products.
            </p>
            <p>
                <strong>10.6.</strong> Notwithstanding the above, if we are held liable, our
                liability to you or a third party is limited to the greater of:
            </p>
            <p>
                <strong>10.6.1.</strong> The total fees you paid us in the 12 months preceding the
                action giving rise to the liability ; and,
            </p>
            <p><strong>10.6.2.</strong> $ 150,00 CAD.</p>
            <p>
                <strong>10.7.</strong> You agree that your use of the Products is "as is" and
                "subject to availability". As mentioned above, we make no representations or
                warranties with respect to the availability of the Products, including, without
                limitation, its completeness, accuracy and reliability.
            </p>
            <p>
                <strong>10.8.</strong> In the event of a dispute with one or more Activix Users or
                Customers you agree to release us (as well as our officers, directors, shareholders,
                agents, subsidiaries, joint ventures, employees and licensors) of any claim, claim
                or damage arising out of one way or another of this dispute.
            </p>
            <p>
                <strong>10.9.</strong> You agree to indemnify us (and our officers, directors,
                shareholders, agents, subsidiaries, joint ventures, employees, and licensors) for
                any and all claims including reasonable judicial and extrajudicial fees incurred as
                a result of your breach of these Terms because of any Content that you submit, post,
                transmit or make available through the Services, your use of the Services, your
                connection to the Services, or your infringement of the rights of others as well as
                your violation of the law.
            </p>
            <p>
                <strong>10.10.</strong> You acknowledge that we are not responsible for
                unpredictable events, such as events of force majeure, or any other event beyond our
                control.
            </p>
            <p>
                <strong>10.11.</strong> Since Activix Inc. is a duly incorporated legal entity, its
                shareholders, directors, officers, employees and consultants will in no way be
                liable for any damages arising in any way from the access and use of the Products.
            </p>
            <p>
                <strong>10.12.</strong> Unless otherwise indicated, any exclusion and limitation of
                liability shall also apply to the Additional Terms, if any.
            </p>

            <h4>11. Final Provisions</h4>
            <p>
                <strong>11.1.</strong> Activix Inc. may, in its sole discretion, modify, add to or
                delete these Terms, in whole or in part, for legal, technical or regulatory
                purposes, as it deems necessary or as a result of a change in the Services provided,
                the nature or presentation of the Products. Your continued access or use of the
                Products indicates that you agree with these changes.
            </p>
            <p>
                <strong>11.2.</strong> Unless otherwise specified in these Terms, any notice from
                you to us must be sent in writing to our email address at info@activix.ca and any
                notice of us to you will be posted on our Products in a timely manner.
            </p>
            <p>
                <strong>11.3.</strong> If any provision of these Terms is found by a court of
                competent jurisdiction to be invalid, including, but not limited to, the above
                exclusions and limitations of liability provisions, the invalid or unenforceable
                provision shall be deemed to be superseded by a provision valid that will correspond
                to the intent of the original provision and the remaining provisions of the Terms
                will remain in effect.
            </p>
            <p>
                <strong>11.4.</strong> You may not assign your rights and obligations under this
                Agreement to any other party without our prior written consent.
            </p>
            <p>
                <strong>11.5.</strong> The User expressly acknowledges that the Products will be
                deemed to be based in Montreal, in the province of Quebec in Canada. These Terms
                shall be governed by and construed in accordance with the laws of the Province of
                Quebec and the federal laws of Canada applicable to them and, barring any lawful
                public policy provision, any legal proceedings instituted hereunder Conditions will
                be exclusive jurisdiction of the courts of the judicial district of Montreal.
            </p>
            <p>
                <strong>11.6.</strong> These Terms (and any other provisions mentioned above)
                constitute the entire rights and obligations that bind us to you with respect to the
                access and use of the Products and supersede any prior or current communication and
                it is electronic, oral, or written. A printed version of these Terms and any
                information provided in electronic format is admissible in evidence to the same
                extent and under the same conditions as other means of proof.
            </p>
        </div>
    </div>
</template>
